import React from 'react';
import { motion } from 'framer-motion';

const profiles = [
    {
        n: '01',
        title: 'Operadores turísticos',
        desc: 'Que quieren abrir canales B2B con receptivos y mayoristas europeos.',
        icon: '⛰',
    },
    {
        n: '02',
        title: 'Agencias de viajes',
        desc: 'Que buscan alianzas de emisión y comisiones más rentables en Europa.',
        icon: '✈',
    },
    {
        n: '03',
        title: 'Hoteles y cadenas',
        desc: 'Que necesitan contratación directa con OTAs, wholesalers y MICE.',
        icon: '★',
    },
    {
        n: '04',
        title: 'Asociaciones gremiales',
        desc: 'Que representan a un sector y quieren posicionar su destino con peso.',
        icon: '◆',
    },
    {
        n: '05',
        title: 'Autoridades y destinos',
        desc: 'Ministerios, oficinas de turismo y viceministerios listos para vender país.',
        icon: '◐',
    },
    {
        n: '06',
        title: 'Cajas de compensación',
        desc: 'Con operación turística que quieren escalar producto e innovación.',
        icon: '❋',
    },
];

const TargetProfiles = () => (
    <section id="perfiles" className="relative py-16 md:py-20 border-t border-white/10 bg-topo overflow-hidden">
        <div className="mx-auto max-w-[1440px] px-6 md:px-10">
            <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-80px' }}
                transition={{ duration: 0.7 }}
                className="mb-8 md:mb-8 grid grid-cols-12 gap-5 md:gap-8"
            >
                <div className="col-span-12 md:col-span-7">
                    <div className="eyebrow-brand mb-6">Para quién es esta misión</div>
                    <h2 className="font-display text-white text-3xl sm:text-4xl md:text-5xl lg:text-6xl">
                        Si vives del turismo en LATAM,<br />
                        <span className="italic-accent text-[color:var(--brand)] font-normal">esto es para ti.</span>
                    </h2>
                </div>
                <div className="col-span-12 md:col-span-5 md:pt-4">
                    <p className="text-white/70 text-lg leading-relaxed">
                        Seis perfiles, un mismo problema: FITUR es enorme y sin ruta no hay retorno.
                        En esta misión vas acompañado, con agenda pre-armada y estrategia clara.
                    </p>
                </div>
            </motion.div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10 border border-white/10">
                {profiles.map((p, i) => (
                    <motion.div
                        key={p.n}
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        whileHover={{ y: -6 }}
                        viewport={{ once: true, margin: '-60px' }}
                        transition={{ duration: 0.6, delay: (i % 3) * 0.08 }}
                        className="group relative bg-[color:var(--bg)] p-8 md:p-10 min-h-[240px] flex flex-col justify-between overflow-hidden"
                    >
                        <div className="pointer-events-none absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500" style={{ background: 'radial-gradient(closest-side at 50% 0%, rgba(225,29,72,0.12), transparent 70%)' }} />
                        <div className="relative flex items-start justify-between">
                            <span className="num-display text-white/40 text-2xl">{p.n}</span>
                            <span className="text-3xl text-[color:var(--brand)]">{p.icon}</span>
                        </div>
                        <div className="relative">
                            <div className="font-display text-white text-2xl md:text-3xl mb-3">{p.title}</div>
                            <div className="text-white/70 leading-relaxed text-sm md:text-base">{p.desc}</div>
                        </div>
                    </motion.div>
                ))}
            </div>
        </div>
    </section>
);

export default TargetProfiles;
